var _desc, _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCenterImageExample(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "280px",
    height: "281px",
    viewBox: "0 0 280 281",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "quest_agil") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "path-1",
    cx: 140,
    cy: 140.649107,
    rx: 140,
    ry: 140.235294
  }), /*#__PURE__*/React.createElement("filter", {
    x: "0.0%",
    y: "0.0%",
    width: "100.0%",
    height: "100.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-5.0%",
    y: "-0.9%",
    width: "110.1%",
    height: "101.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.83331893,26.8160456 L64.3318684,0.434031528 C65.0786431,0.118801467 65.9211983,0.119176714 66.6676919,0.435071826 L95.2061795,12.5117569 C96.3159699,12.981389 97.037037,14.0694965 97.037037,15.2745646 L97.037037,31.107413 C97.037037,32.3134527 96.3148215,33.4022397 95.2037181,33.8712609 L32.7051686,60.253275 C31.9583939,60.568505 31.1158388,60.5681298 30.3693451,60.2522347 L1.83085754,48.1755496 C0.721067146,47.7059175 -2.96510937e-16,46.61781 0,45.412742 L0,29.5798935 C7.40481155e-16,28.3738538 0.722215501,27.2850668 1.83331893,26.8160456 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.83331893,26.8022643 L64.3318684,0.420250171 C65.0786431,0.105020111 65.9211983,0.105395357 66.6676919,0.42129047 L95.2061795,12.4979756 C96.3159699,12.9676077 97.037037,14.0557151 97.037037,15.2607832 L97.037037,31.0936316 C97.037037,32.2996713 96.3148215,33.3884583 95.2037181,33.8574795 L32.7051686,60.2394936 C31.9583939,60.5547237 31.1158388,60.5543484 30.3693451,60.2384533 L1.83085754,48.1617682 C0.721067146,47.6921361 -2.9610462e-15,46.6040286 0,45.3989606 L0,29.5661122 C2.3472488e-15,28.3600725 0.722215501,27.2712855 1.83331893,26.8022643 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L12,0 L12,5.29411765 C12,6.59361118 9.3137085,7.64705882 6,7.64705882 C2.6862915,7.64705882 0,6.59361118 0,5.29411765 L0,5.29411765 L0,0 Z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "13.8144003%",
    y1: "41.5264423%",
    x2: "81.9362331%",
    y2: "41.5264423%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.1,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818181",
    stopOpacity: 0,
    offset: "49.9196889%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.2,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L12,0 L12,5.29411765 C12,6.59361118 9.3137085,7.64705882 6,7.64705882 C2.6862915,7.64705882 0,6.59361118 0,5.29411765 L0,5.29411765 L0,0 Z",
    id: "path-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L12,0 L12,5.29411765 C12,6.59361118 9.3137085,7.64705882 6,7.64705882 C2.6862915,7.64705882 0,6.59361118 0,5.29411765 L0,5.29411765 L0,0 Z",
    id: "path-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L12,0 L12,5.29411765 C12,6.59361118 9.3137085,7.64705882 6,7.64705882 C2.6862915,7.64705882 0,6.59361118 0,5.29411765 L0,5.29411765 L0,0 Z",
    id: "path-16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L12,0 L12,5.29411765 C12,6.59361118 9.3137085,7.64705882 6,7.64705882 C2.6862915,7.64705882 0,6.59361118 0,5.29411765 L0,5.29411765 L0,0 Z",
    id: "path-18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.83331893,26.8160456 L64.3318684,0.434031528 C65.0786431,0.118801467 65.9211983,0.119176714 66.6676919,0.435071826 L95.2061795,12.5117569 C96.3159699,12.981389 97.037037,14.0694965 97.037037,15.2745646 L97.037037,31.107413 C97.037037,32.3134527 96.3148215,33.4022397 95.2037181,33.8712609 L32.7051686,60.253275 C31.9583939,60.568505 31.1158388,60.5681298 30.3693451,60.2522347 L1.83085754,48.1755496 C0.721067146,47.7059175 -2.9610462e-15,46.61781 0,45.412742 L0,29.5798935 C2.3472488e-15,28.3738538 0.722215501,27.2850668 1.83331893,26.8160456 Z",
    id: "path-20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.83331893,26.8022643 L64.3318684,0.420250171 C65.0786431,0.105020111 65.9211983,0.105395357 66.6676919,0.42129047 L95.2061795,12.4979756 C96.3159699,12.9676077 97.037037,14.0557151 97.037037,15.2607832 L97.037037,31.0936316 C97.037037,32.2996713 96.3148215,33.3884583 95.2037181,33.8574795 L32.7051686,60.2394936 C31.9583939,60.5547237 31.1158388,60.5543484 30.3693451,60.2384533 L1.83085754,48.1617682 C0.721067146,47.6921361 -2.9610462e-15,46.6040286 0,45.3989606 L0,29.5661122 C2.3472488e-15,28.3600725 0.722215501,27.2712855 1.83331893,26.8022643 Z",
    id: "path-22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L12,0 L12,5.29411765 C12,6.59361118 9.3137085,7.64705882 6,7.64705882 C2.6862915,7.64705882 0,6.59361118 0,5.29411765 L0,5.29411765 L0,0 Z",
    id: "path-24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L12,0 L12,5.29411765 C12,6.59361118 9.3137085,7.64705882 6,7.64705882 C2.6862915,7.64705882 0,6.59361118 0,5.29411765 L0,5.29411765 L0,0 Z",
    id: "path-26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L12,0 L12,5.29411765 C12,6.59361118 9.3137085,7.64705882 6,7.64705882 C2.6862915,7.64705882 0,6.59361118 0,5.29411765 L0,5.29411765 L0,0 Z",
    id: "path-28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L12,0 L12,5.29411765 C12,6.59361118 9.3137085,7.64705882 6,7.64705882 C2.6862915,7.64705882 0,6.59361118 0,5.29411765 L0,5.29411765 L0,0 Z",
    id: "path-30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.83085754,12.497804 L30.3678946,0.421732748 C31.1152423,0.105476233 31.9588318,0.105476233 32.7061795,0.421732748 L61.2432165,12.497804 C62.3530069,12.9674361 63.0740741,14.0555436 63.0740741,15.2606116 L63.0740741,31.0953835 C63.0740741,32.3004515 62.3530069,33.388559 61.2432165,33.8581911 L32.7061795,45.9342624 C31.9588318,46.2505189 31.1152423,46.2505189 30.3678946,45.9342624 L1.83085754,33.8581911 C0.721067146,33.388559 1.75305143e-15,32.3004515 0,31.0953835 L0,15.2606116 C1.71984707e-15,14.0555436 0.721067146,12.9674361 1.83085754,12.497804 Z",
    id: "path-32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L12,0 L12,5.29411765 C12,6.59361118 9.3137085,7.64705882 6,7.64705882 C2.6862915,7.64705882 0,6.59361118 0,5.29411765 L0,5.29411765 L0,0 Z",
    id: "path-34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L12,0 L12,5.29411765 C12,6.59361118 9.3137085,7.64705882 6,7.64705882 C2.6862915,7.64705882 0,6.59361118 0,5.29411765 L0,5.29411765 L0,0 Z",
    id: "path-36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L12,0 L12,5.29411765 C12,6.59361118 9.3137085,7.64705882 6,7.64705882 C2.6862915,7.64705882 0,6.59361118 0,5.29411765 L0,5.29411765 L0,0 Z",
    id: "path-38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L12,0 L12,5.29411765 C12,6.59361118 9.3137085,7.64705882 6,7.64705882 C2.6862915,7.64705882 0,6.59361118 0,5.29411765 L0,5.29411765 L0,0 Z",
    id: "path-40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L12,0 L12,5.29411765 C12,6.59361118 9.3137085,7.64705882 6,7.64705882 C2.6862915,7.64705882 0,6.59361118 0,5.29411765 L0,5.29411765 L0,0 Z",
    id: "path-42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L12,0 L12,5.29411765 C12,6.59361118 9.3137085,7.64705882 6,7.64705882 C2.6862915,7.64705882 0,6.59361118 0,5.29411765 L0,5.29411765 L0,0 Z",
    id: "path-44"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "0.0%",
    y: "0.0%",
    width: "100.0%",
    height: "100.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-46"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0,
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NEw",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RGPD-Copy-3",
    transform: "translate(-659.000000, -251.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(648.000000, 241.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "top"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Circle/default",
    transform: "translate(11.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_Isometric",
    transform: "translate(0.000000, 7.011765)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "o",
    fillOpacity: 0.85,
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,196.329412 C114.066022,174.25937 165.933978,174.25937 210,196.329412 C229.329966,206.010639 237.164983,229.555193 227.5,248.917647 C223.713521,256.503332 217.572957,262.654216 210,266.447059 C165.933978,288.5171 114.066022,288.5171 70,266.447059 C50.6700338,256.765832 42.8350169,233.221277 52.5,213.858824 C56.2864787,206.273138 62.4270425,200.122254 70,196.329412 Z",
    id: "Path",
    fillOpacity: 0.05,
    fill: "#000000",
    filter: "url(#filter-3)",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.785252,226.988226 L139.552185,210.577225 C139.834041,210.43606 140.165959,210.43606 140.447815,210.577225 L173.214748,226.988226 C173.70856,227.235548 173.908381,227.836355 173.661059,228.330168 C173.564372,228.523219 173.407799,228.679792 173.214748,228.776479 L140.447815,245.187481 C140.165959,245.328646 139.834041,245.328646 139.552185,245.187481 L106.785252,228.776479 C106.29144,228.529158 106.091619,227.928351 106.338941,227.434538 C106.435628,227.241487 106.592201,227.084914 106.785252,226.988226 Z",
    id: "Rectangle_Top_Isometric-Copy",
    fillOpacity: 0.07,
    fill: "#000000",
    filter: "url(#filter-4)",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cube/colored-copy-3",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.000000, 28.047059)",
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.375000, 46.117647)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_Isometric-Copy-6",
    transform: "translate(16.981481, 71.312693)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle_bg-Copy",
    fill: "#F2602D",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle_Left_Isometric-Copy",
    fillOpacity: 0.1,
    fill: "#000000",
    mask: "url(#mask-6)",
    points: "31.537037 60.6873065 0 47.3584187 0 27.5851393 31.537037 40.9140271"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle_Right_Isometric-Copy",
    fillOpacity: 0.2,
    fill: "#FFFFFF",
    mask: "url(#mask-6)",
    points: "31.537037 60.6873065 97.037037 33.0550131 97.037037 13.2817337 31.537037 40.9140271"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_Isometric-Copy-5",
    transform: "translate(26.685185, 44.136223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(7.277778, 0.218116)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle_bg-Copy",
    fill: "#32C77F",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle_Left_Isometric-Copy",
    fillOpacity: 0.1,
    fill: "#000000",
    mask: "url(#mask-8)",
    points: "31.537037 60.6735251 0 47.3446373 0 27.571358 31.537037 40.9002458"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle_Right_Isometric-Copy",
    fillOpacity: 0.2,
    fill: "#FFFFFF",
    mask: "url(#mask-8)",
    points: "31.537037 60.6735251 97.037037 33.0412317 97.037037 13.2679524 31.537037 40.9002458"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cube/lego",
    transform: "translate(0.000000, 45.975232)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_Isometric",
    strokeWidth: 1,
    transform: "translate(0.000000, 2.352941)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.634912471,-0.248985283 L5.63491247,-2.2097696 C5.8696036,-2.30180533 6.1303964,-2.30180533 6.36508753,-2.2097696 L11.3650875,-0.248985283 C11.7480697,-0.098796206 12,0.270609644 12,0.681987916 L12,7.31801208 C12,7.72939036 11.7480697,8.09879621 11.3650875,8.24898528 L6.36508753,10.2097696 C6.1303964,10.3018053 5.8696036,10.3018053 5.63491247,10.2097696 L0.634912471,8.24898528 C0.251930325,8.09879621 -4.58330694e-16,7.72939036 0,7.31801208 L0,0.681987916 C3.93709901e-16,0.270609644 0.251930325,-0.098796206 0.634912471,-0.248985283 Z",
    id: "Rectangle_bg-Copy",
    fill: "#F2602D",
    mask: "url(#mask-10)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-11)",
    mask: "url(#mask-10)",
    x: 0,
    y: 0,
    width: 12,
    height: 7.64705882
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-3",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#FFFFFF",
    opacity: 0.2,
    mask: "url(#mask-10)",
    cx: 6,
    cy: 0,
    rx: 6.15,
    ry: 2.47058824
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F2602D",
    cx: 6,
    cy: 2.35294118,
    rx: 6,
    ry: 2.35294118
  })), /*#__PURE__*/React.createElement("g", {
    id: "cube/lego",
    transform: "translate(16.011111, 51.287926)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_Isometric",
    strokeWidth: 1,
    transform: "translate(0.000000, 2.352941)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-13",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.634912471,-0.248985283 L5.63491247,-2.2097696 C5.8696036,-2.30180533 6.1303964,-2.30180533 6.36508753,-2.2097696 L11.3650875,-0.248985283 C11.7480697,-0.098796206 12,0.270609644 12,0.681987916 L12,7.31801208 C12,7.72939036 11.7480697,8.09879621 11.3650875,8.24898528 L6.36508753,10.2097696 C6.1303964,10.3018053 5.8696036,10.3018053 5.63491247,10.2097696 L0.634912471,8.24898528 C0.251930325,8.09879621 -4.58330694e-16,7.72939036 0,7.31801208 L0,0.681987916 C3.93709901e-16,0.270609644 0.251930325,-0.098796206 0.634912471,-0.248985283 Z",
    id: "Rectangle_bg-Copy",
    fill: "#F2602D",
    mask: "url(#mask-13)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-11)",
    mask: "url(#mask-13)",
    x: 0,
    y: 0,
    width: 12,
    height: 7.64705882
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-3",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#FFFFFF",
    opacity: 0.2,
    mask: "url(#mask-13)",
    cx: 6,
    cy: 0,
    rx: 6.15,
    ry: 2.47058824
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F2602D",
    cx: 6,
    cy: 2.35294118,
    rx: 6,
    ry: 2.35294118
  })), /*#__PURE__*/React.createElement("g", {
    id: "cube/lego",
    transform: "translate(81.996296, 5.312693)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_Isometric",
    strokeWidth: 1,
    transform: "translate(0.000000, 2.352941)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-15",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-14"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.634912471,-0.248985283 L5.63491247,-2.2097696 C5.8696036,-2.30180533 6.1303964,-2.30180533 6.36508753,-2.2097696 L11.3650875,-0.248985283 C11.7480697,-0.098796206 12,0.270609644 12,0.681987916 L12,7.31801208 C12,7.72939036 11.7480697,8.09879621 11.3650875,8.24898528 L6.36508753,10.2097696 C6.1303964,10.3018053 5.8696036,10.3018053 5.63491247,10.2097696 L0.634912471,8.24898528 C0.251930325,8.09879621 -4.58330694e-16,7.72939036 0,7.31801208 L0,0.681987916 C3.93709901e-16,0.270609644 0.251930325,-0.098796206 0.634912471,-0.248985283 Z",
    id: "Rectangle_bg-Copy",
    fill: "#32C77F",
    mask: "url(#mask-15)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-11)",
    mask: "url(#mask-15)",
    x: 0,
    y: 0,
    width: 12,
    height: 7.64705882
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-3",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#FFFFFF",
    opacity: 0.2,
    mask: "url(#mask-15)",
    cx: 6,
    cy: 0,
    rx: 6.15,
    ry: 2.47058824
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#32C77F",
    cx: 6,
    cy: 2.35294118,
    rx: 6,
    ry: 2.35294118
  })), /*#__PURE__*/React.createElement("g", {
    id: "cube/lego",
    transform: "translate(65.985185, 10.625387)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_Isometric",
    strokeWidth: 1,
    transform: "translate(0.000000, 2.352941)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-17",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.634912471,-0.248985283 L5.63491247,-2.2097696 C5.8696036,-2.30180533 6.1303964,-2.30180533 6.36508753,-2.2097696 L11.3650875,-0.248985283 C11.7480697,-0.098796206 12,0.270609644 12,0.681987916 L12,7.31801208 C12,7.72939036 11.7480697,8.09879621 11.3650875,8.24898528 L6.36508753,10.2097696 C6.1303964,10.3018053 5.8696036,10.3018053 5.63491247,10.2097696 L0.634912471,8.24898528 C0.251930325,8.09879621 -4.58330694e-16,7.72939036 0,7.31801208 L0,0.681987916 C3.93709901e-16,0.270609644 0.251930325,-0.098796206 0.634912471,-0.248985283 Z",
    id: "Rectangle_bg-Copy",
    fill: "#32C77F",
    mask: "url(#mask-17)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-11)",
    mask: "url(#mask-17)",
    x: 0,
    y: 0,
    width: 12,
    height: 7.64705882
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-3",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#FFFFFF",
    opacity: 0.2,
    mask: "url(#mask-17)",
    cx: 6,
    cy: 0,
    rx: 6.15,
    ry: 2.47058824
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#32C77F",
    cx: 6,
    cy: 2.35294118,
    rx: 6,
    ry: 2.35294118
  })), /*#__PURE__*/React.createElement("g", {
    id: "cube/lego",
    transform: "translate(65.985185, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_Isometric",
    strokeWidth: 1,
    transform: "translate(0.000000, 2.352941)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-19",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-18"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.634912471,-0.248985283 L5.63491247,-2.2097696 C5.8696036,-2.30180533 6.1303964,-2.30180533 6.36508753,-2.2097696 L11.3650875,-0.248985283 C11.7480697,-0.098796206 12,0.270609644 12,0.681987916 L12,7.31801208 C12,7.72939036 11.7480697,8.09879621 11.3650875,8.24898528 L6.36508753,10.2097696 C6.1303964,10.3018053 5.8696036,10.3018053 5.63491247,10.2097696 L0.634912471,8.24898528 C0.251930325,8.09879621 -4.58330694e-16,7.72939036 0,7.31801208 L0,0.681987916 C3.93709901e-16,0.270609644 0.251930325,-0.098796206 0.634912471,-0.248985283 Z",
    id: "Rectangle_bg-Copy",
    fill: "#32C77F",
    mask: "url(#mask-19)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-11)",
    mask: "url(#mask-19)",
    x: 0,
    y: 0,
    width: 12,
    height: 7.64705882
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-3",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#FFFFFF",
    opacity: 0.2,
    mask: "url(#mask-19)",
    cx: 6,
    cy: 0,
    rx: 6.15,
    ry: 2.47058824
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#32C77F",
    cx: 6,
    cy: 2.35294118,
    rx: 6,
    ry: 2.35294118
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_Isometric-Copy-4",
    transform: "translate(0.000000, 39.027864)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-21",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-20"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle_bg-Copy",
    fill: "#F8E71C",
    xlinkHref: "#path-20"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle_Left_Isometric-Copy",
    fillOpacity: 0.1,
    fill: "#000000",
    mask: "url(#mask-21)",
    points: "31.537037 60.6873065 0 47.3584187 0 27.5851393 31.537037 40.9140271"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle_Right_Isometric-Copy",
    fillOpacity: 0.2,
    fill: "#FFFFFF",
    mask: "url(#mask-21)",
    points: "31.537037 60.6873065 97.037037 33.0550131 97.037037 13.2817337 31.537037 40.9140271"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_Isometric-Copy-3",
    transform: "translate(9.703704, 12.464396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(7.277778, 0.013781)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-23",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-22"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle_bg-Copy",
    fill: "#93CCFF",
    xlinkHref: "#path-22"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle_Left_Isometric-Copy",
    fillOpacity: 0.1,
    fill: "#000000",
    mask: "url(#mask-23)",
    points: "31.537037 60.6735251 0 47.3446373 0 27.571358 31.537037 40.9002458"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle_Right_Isometric-Copy",
    fillOpacity: 0.2,
    fill: "#FFFFFF",
    mask: "url(#mask-23)",
    points: "31.537037 60.6735251 97.037037 33.0412317 97.037037 13.2679524 31.537037 40.9002458"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cube/lego",
    transform: "translate(0.000000, 45.975232)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_Isometric",
    strokeWidth: 1,
    transform: "translate(0.000000, 2.352941)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-25",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.634912471,-0.248985283 L5.63491247,-2.2097696 C5.8696036,-2.30180533 6.1303964,-2.30180533 6.36508753,-2.2097696 L11.3650875,-0.248985283 C11.7480697,-0.098796206 12,0.270609644 12,0.681987916 L12,7.31801208 C12,7.72939036 11.7480697,8.09879621 11.3650875,8.24898528 L6.36508753,10.2097696 C6.1303964,10.3018053 5.8696036,10.3018053 5.63491247,10.2097696 L0.634912471,8.24898528 C0.251930325,8.09879621 -4.58330694e-16,7.72939036 0,7.31801208 L0,0.681987916 C3.93709901e-16,0.270609644 0.251930325,-0.098796206 0.634912471,-0.248985283 Z",
    id: "Rectangle_bg-Copy",
    fill: "#F8E71C",
    mask: "url(#mask-25)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-11)",
    mask: "url(#mask-25)",
    x: 0,
    y: 0,
    width: 12,
    height: 7.64705882
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-3",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#FFFFFF",
    opacity: 0.2,
    mask: "url(#mask-25)",
    cx: 6,
    cy: 0,
    rx: 6.15,
    ry: 2.47058824
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F8E71C",
    cx: 6,
    cy: 2.35294118,
    rx: 6,
    ry: 2.35294118
  })), /*#__PURE__*/React.createElement("g", {
    id: "cube/lego",
    transform: "translate(16.011111, 51.287926)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_Isometric",
    strokeWidth: 1,
    transform: "translate(0.000000, 2.352941)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-27",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.634912471,-0.248985283 L5.63491247,-2.2097696 C5.8696036,-2.30180533 6.1303964,-2.30180533 6.36508753,-2.2097696 L11.3650875,-0.248985283 C11.7480697,-0.098796206 12,0.270609644 12,0.681987916 L12,7.31801208 C12,7.72939036 11.7480697,8.09879621 11.3650875,8.24898528 L6.36508753,10.2097696 C6.1303964,10.3018053 5.8696036,10.3018053 5.63491247,10.2097696 L0.634912471,8.24898528 C0.251930325,8.09879621 -4.58330694e-16,7.72939036 0,7.31801208 L0,0.681987916 C3.93709901e-16,0.270609644 0.251930325,-0.098796206 0.634912471,-0.248985283 Z",
    id: "Rectangle_bg-Copy",
    fill: "#F8E71C",
    mask: "url(#mask-27)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-11)",
    mask: "url(#mask-27)",
    x: 0,
    y: 0,
    width: 12,
    height: 7.64705882
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-3",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#FFFFFF",
    opacity: 0.2,
    mask: "url(#mask-27)",
    cx: 6,
    cy: 0,
    rx: 6.15,
    ry: 2.47058824
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F8E71C",
    cx: 6,
    cy: 2.35294118,
    rx: 6,
    ry: 2.35294118
  })), /*#__PURE__*/React.createElement("g", {
    id: "cube/lego",
    transform: "translate(66.955556, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_Isometric",
    strokeWidth: 1,
    transform: "translate(0.000000, 2.352941)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-29",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.634912471,-0.248985283 L5.63491247,-2.2097696 C5.8696036,-2.30180533 6.1303964,-2.30180533 6.36508753,-2.2097696 L11.3650875,-0.248985283 C11.7480697,-0.098796206 12,0.270609644 12,0.681987916 L12,7.31801208 C12,7.72939036 11.7480697,8.09879621 11.3650875,8.24898528 L6.36508753,10.2097696 C6.1303964,10.3018053 5.8696036,10.3018053 5.63491247,10.2097696 L0.634912471,8.24898528 C0.251930325,8.09879621 -4.58330694e-16,7.72939036 0,7.31801208 L0,0.681987916 C3.93709901e-16,0.270609644 0.251930325,-0.098796206 0.634912471,-0.248985283 Z",
    id: "Rectangle_bg-Copy",
    fill: "#93CCFF",
    mask: "url(#mask-29)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-11)",
    mask: "url(#mask-29)",
    x: 0,
    y: 0,
    width: 12,
    height: 7.64705882
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-3",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#FFFFFF",
    opacity: 0.2,
    mask: "url(#mask-29)",
    cx: 6,
    cy: 0,
    rx: 6.15,
    ry: 2.47058824
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#93CCFF",
    cx: 6,
    cy: 2.35294118,
    rx: 6,
    ry: 2.35294118
  })), /*#__PURE__*/React.createElement("g", {
    id: "cube/lego",
    transform: "translate(82.966667, 5.312693)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_Isometric",
    strokeWidth: 1,
    transform: "translate(0.000000, 2.352941)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-31",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-30"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.634912471,-0.248985283 L5.63491247,-2.2097696 C5.8696036,-2.30180533 6.1303964,-2.30180533 6.36508753,-2.2097696 L11.3650875,-0.248985283 C11.7480697,-0.098796206 12,0.270609644 12,0.681987916 L12,7.31801208 C12,7.72939036 11.7480697,8.09879621 11.3650875,8.24898528 L6.36508753,10.2097696 C6.1303964,10.3018053 5.8696036,10.3018053 5.63491247,10.2097696 L0.634912471,8.24898528 C0.251930325,8.09879621 -4.58330694e-16,7.72939036 0,7.31801208 L0,0.681987916 C3.93709901e-16,0.270609644 0.251930325,-0.098796206 0.634912471,-0.248985283 Z",
    id: "Rectangle_bg-Copy",
    fill: "#93CCFF",
    mask: "url(#mask-31)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-11)",
    mask: "url(#mask-31)",
    x: 0,
    y: 0,
    width: 12,
    height: 7.64705882
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-3",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#FFFFFF",
    opacity: 0.2,
    mask: "url(#mask-31)",
    cx: 6,
    cy: 0,
    rx: 6.15,
    ry: 2.47058824
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#93CCFF",
    cx: 6,
    cy: 2.35294118,
    rx: 6,
    ry: 2.35294118
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_Isometric-Copy-2",
    transform: "translate(26.685185, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(7.277778, 0.013953)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-33",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-32"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle_bg-Copy",
    fill: "#FF7675",
    xlinkHref: "#path-32"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle_Left_Isometric-Copy",
    fillOpacity: 0.1,
    fill: "#000000",
    mask: "url(#mask-33)",
    points: "31.537037 46.369948 0 33.0410602 0 13.2677808 31.537037 26.5966687"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle_Right_Isometric-Copy",
    fillOpacity: 0.2,
    fill: "#FFFFFF",
    mask: "url(#mask-33)",
    points: "31.537037 46.369948 63.0740741 33.0410602 63.0740741 13.2677808 31.537037 26.5966687"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cube/lego",
    transform: "translate(0.000000, 32.080495)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_Isometric",
    strokeWidth: 1,
    transform: "translate(0.000000, 2.352941)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-35",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.634912471,-0.248985283 L5.63491247,-2.2097696 C5.8696036,-2.30180533 6.1303964,-2.30180533 6.36508753,-2.2097696 L11.3650875,-0.248985283 C11.7480697,-0.098796206 12,0.270609644 12,0.681987916 L12,7.31801208 C12,7.72939036 11.7480697,8.09879621 11.3650875,8.24898528 L6.36508753,10.2097696 C6.1303964,10.3018053 5.8696036,10.3018053 5.63491247,10.2097696 L0.634912471,8.24898528 C0.251930325,8.09879621 -4.58330694e-16,7.72939036 0,7.31801208 L0,0.681987916 C3.93709901e-16,0.270609644 0.251930325,-0.098796206 0.634912471,-0.248985283 Z",
    id: "Rectangle_bg-Copy",
    fill: "#93CCFF",
    mask: "url(#mask-35)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-11)",
    mask: "url(#mask-35)",
    x: 0,
    y: 0,
    width: 12,
    height: 7.64705882
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-3",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#FFFFFF",
    opacity: 0.2,
    mask: "url(#mask-35)",
    cx: 6,
    cy: 0,
    rx: 6.15,
    ry: 2.47058824
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#93CCFF",
    cx: 6,
    cy: 2.35294118,
    rx: 6,
    ry: 2.35294118
  })), /*#__PURE__*/React.createElement("g", {
    id: "cube/lego",
    transform: "translate(16.011111, 37.393189)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_Isometric",
    strokeWidth: 1,
    transform: "translate(0.000000, 2.352941)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-37",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.634912471,-0.248985283 L5.63491247,-2.2097696 C5.8696036,-2.30180533 6.1303964,-2.30180533 6.36508753,-2.2097696 L11.3650875,-0.248985283 C11.7480697,-0.098796206 12,0.270609644 12,0.681987916 L12,7.31801208 C12,7.72939036 11.7480697,8.09879621 11.3650875,8.24898528 L6.36508753,10.2097696 C6.1303964,10.3018053 5.8696036,10.3018053 5.63491247,10.2097696 L0.634912471,8.24898528 C0.251930325,8.09879621 -4.58330694e-16,7.72939036 0,7.31801208 L0,0.681987916 C3.93709901e-16,0.270609644 0.251930325,-0.098796206 0.634912471,-0.248985283 Z",
    id: "Rectangle_bg-Copy",
    fill: "#93CCFF",
    mask: "url(#mask-37)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-11)",
    mask: "url(#mask-37)",
    x: 0,
    y: 0,
    width: 12,
    height: 7.64705882
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-3",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#FFFFFF",
    opacity: 0.2,
    mask: "url(#mask-37)",
    cx: 6,
    cy: 0,
    rx: 6.15,
    ry: 2.47058824
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#93CCFF",
    cx: 6,
    cy: 2.35294118,
    rx: 6,
    ry: 2.35294118
  })))), /*#__PURE__*/React.createElement("g", {
    id: "cube/lego",
    transform: "translate(76.174074, 4.495356)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_Isometric",
    strokeWidth: 1,
    transform: "translate(0.000000, 2.352941)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-39",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.634912471,-0.248985283 L5.63491247,-2.2097696 C5.8696036,-2.30180533 6.1303964,-2.30180533 6.36508753,-2.2097696 L11.3650875,-0.248985283 C11.7480697,-0.098796206 12,0.270609644 12,0.681987916 L12,7.31801208 C12,7.72939036 11.7480697,8.09879621 11.3650875,8.24898528 L6.36508753,10.2097696 C6.1303964,10.3018053 5.8696036,10.3018053 5.63491247,10.2097696 L0.634912471,8.24898528 C0.251930325,8.09879621 -4.58330694e-16,7.72939036 0,7.31801208 L0,0.681987916 C3.93709901e-16,0.270609644 0.251930325,-0.098796206 0.634912471,-0.248985283 Z",
    id: "Rectangle_bg-Copy",
    fill: "#FF7675",
    mask: "url(#mask-39)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-11)",
    mask: "url(#mask-39)",
    x: 0,
    y: 0,
    width: 12,
    height: 7.64705882
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-3",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#FFFFFF",
    opacity: 0.2,
    mask: "url(#mask-39)",
    cx: 6,
    cy: 0,
    rx: 6.15,
    ry: 2.47058824
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FF7675",
    cx: 6,
    cy: 2.35294118,
    rx: 6,
    ry: 2.35294118
  })), /*#__PURE__*/React.createElement("g", {
    id: "cube/lego",
    transform: "translate(59.435185, 11.442724)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_Isometric",
    strokeWidth: 1,
    transform: "translate(0.000000, 2.352941)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-41",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-40"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.634912471,-0.248985283 L5.63491247,-2.2097696 C5.8696036,-2.30180533 6.1303964,-2.30180533 6.36508753,-2.2097696 L11.3650875,-0.248985283 C11.7480697,-0.098796206 12,0.270609644 12,0.681987916 L12,7.31801208 C12,7.72939036 11.7480697,8.09879621 11.3650875,8.24898528 L6.36508753,10.2097696 C6.1303964,10.3018053 5.8696036,10.3018053 5.63491247,10.2097696 L0.634912471,8.24898528 C0.251930325,8.09879621 -4.58330694e-16,7.72939036 0,7.31801208 L0,0.681987916 C3.93709901e-16,0.270609644 0.251930325,-0.098796206 0.634912471,-0.248985283 Z",
    id: "Rectangle_bg-Copy",
    fill: "#FF7675",
    mask: "url(#mask-41)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-11)",
    mask: "url(#mask-41)",
    x: 0,
    y: 0,
    width: 12,
    height: 7.64705882
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-3",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#FFFFFF",
    opacity: 0.2,
    mask: "url(#mask-41)",
    cx: 6,
    cy: 0,
    rx: 6.15,
    ry: 2.47058824
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FF7675",
    cx: 6,
    cy: 2.35294118,
    rx: 6,
    ry: 2.35294118
  })), /*#__PURE__*/React.createElement("g", {
    id: "cube/lego",
    transform: "translate(60.162963, -1.226006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_Isometric",
    strokeWidth: 1,
    transform: "translate(0.000000, 2.352941)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-43",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.634912471,-0.248985283 L5.63491247,-2.2097696 C5.8696036,-2.30180533 6.1303964,-2.30180533 6.36508753,-2.2097696 L11.3650875,-0.248985283 C11.7480697,-0.098796206 12,0.270609644 12,0.681987916 L12,7.31801208 C12,7.72939036 11.7480697,8.09879621 11.3650875,8.24898528 L6.36508753,10.2097696 C6.1303964,10.3018053 5.8696036,10.3018053 5.63491247,10.2097696 L0.634912471,8.24898528 C0.251930325,8.09879621 -4.58330694e-16,7.72939036 0,7.31801208 L0,0.681987916 C3.93709901e-16,0.270609644 0.251930325,-0.098796206 0.634912471,-0.248985283 Z",
    id: "Rectangle_bg-Copy",
    fill: "#FF7675",
    mask: "url(#mask-43)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-11)",
    mask: "url(#mask-43)",
    x: 0,
    y: 0,
    width: 12,
    height: 7.64705882
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-3",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#FFFFFF",
    opacity: 0.2,
    mask: "url(#mask-43)",
    cx: 6,
    cy: 0,
    rx: 6.15,
    ry: 2.47058824
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FF7675",
    cx: 6,
    cy: 2.35294118,
    rx: 6,
    ry: 2.35294118
  })), /*#__PURE__*/React.createElement("g", {
    id: "cube/lego",
    transform: "translate(43.424074, 5.721362)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_Isometric",
    strokeWidth: 1,
    transform: "translate(0.000000, 2.352941)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-45",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.634912471,-0.248985283 L5.63491247,-2.2097696 C5.8696036,-2.30180533 6.1303964,-2.30180533 6.36508753,-2.2097696 L11.3650875,-0.248985283 C11.7480697,-0.098796206 12,0.270609644 12,0.681987916 L12,7.31801208 C12,7.72939036 11.7480697,8.09879621 11.3650875,8.24898528 L6.36508753,10.2097696 C6.1303964,10.3018053 5.8696036,10.3018053 5.63491247,10.2097696 L0.634912471,8.24898528 C0.251930325,8.09879621 -4.58330694e-16,7.72939036 0,7.31801208 L0,0.681987916 C3.93709901e-16,0.270609644 0.251930325,-0.098796206 0.634912471,-0.248985283 Z",
    id: "Rectangle_bg-Copy",
    fill: "#FF7675",
    mask: "url(#mask-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-11)",
    mask: "url(#mask-45)",
    x: 0,
    y: 0,
    width: 12,
    height: 7.64705882
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-3",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#FFFFFF",
    opacity: 0.2,
    mask: "url(#mask-45)",
    cx: 6,
    cy: 0,
    rx: 6.15,
    ry: 2.47058824
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FF7675",
    cx: 6,
    cy: 2.35294118,
    rx: 6,
    ry: 2.35294118
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "M108.557618,7.87072128 C128.753796,-2.62357376 152.525727,-2.62357376 172.721905,7.87072128 C181.581145,12.4741404 185.172061,23.6695659 180.742441,32.8764041 C179.007036,36.483394 176.192715,39.4081367 172.721905,41.2116317 C152.525727,51.7059267 128.753796,51.7059267 108.557618,41.2116317 C99.6983785,36.6082126 96.1074622,25.412787 100.537082,16.2059489 C102.272487,12.5989589 105.086808,9.67421626 108.557618,7.87072128 Z",
    id: "Path-Copy",
    fillOpacity: 0.2,
    fill: "#FFFFFF",
    filter: "url(#filter-46)",
    mask: "url(#mask-2)"
  })))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterImageExample);
export default __webpack_public_path__ + "static/media/center_image_example.2314c97a1c6f655fe8052213a062c8a2.svg";
export { ForwardRef as ReactComponent };